"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineLoadingStatuses = void 0;
function combineLoadingStatuses(loadingStatuses) {
    if (loadingStatuses.length === 0) {
        return 'initial';
    }
    const mappedStatuses = loadingStatuses.map((value) => (typeof value === 'object' ? value.status : value));
    if (mappedStatuses.some((status) => status === 'error')) {
        return 'error';
    }
    if (mappedStatuses.some((status) => status === 'loading')) {
        return 'loading';
    }
    if (mappedStatuses.some((status) => status === 'initial')) {
        return 'initial';
    }
    return 'done';
}
exports.combineLoadingStatuses = combineLoadingStatuses;
